import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Reset window scroll on route change (BrowserRouter has no built-in scroll restoration). */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
